import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { resetPassword } from "../../lib/adminApi";

export default function AdminResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw !== pw2) {
      setErr("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await resetPassword(token, pw);
      nav("/admin/login?reset=1");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Reset failed — the link may be expired");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF8F3] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        data-testid="admin-reset-form"
        className="bg-white border border-[#E7E2D9] p-10 w-full max-w-md shadow-[0_24px_60px_-30px_rgba(17,17,17,0.18)]"
      >
        <img src="/logo.png" alt="Zarco's Decks" className="h-16 w-auto mb-8" />
        <h1 className="font-display text-3xl tracking-tight text-[#111]">Choose a new password</h1>
        {!token && (
          <p className="mt-3 text-sm text-red-600" data-testid="admin-reset-no-token">
            This reset link is missing its token. Request a new one from the sign-in page.
          </p>
        )}
        <label className="block mt-8 text-[11px] uppercase tracking-[0.2em] font-semibold">New password</label>
        <input
          type="password"
          required
          minLength={10}
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          data-testid="admin-reset-password"
          className="mt-2 w-full border-b-2 border-[#E7E2D9] focus:border-[#99582A] py-3 outline-none"
        />
        <label className="block mt-6 text-[11px] uppercase tracking-[0.2em] font-semibold">Confirm password</label>
        <input
          type="password"
          required
          minLength={10}
          value={pw2}
          onChange={(e) => setPw2(e.target.value)}
          data-testid="admin-reset-password-confirm"
          className="mt-2 w-full border-b-2 border-[#E7E2D9] focus:border-[#99582A] py-3 outline-none"
        />
        <p className="mt-3 text-xs text-[#666]">Minimum 10 characters.</p>
        {err && <p className="mt-4 text-sm text-red-600" data-testid="admin-reset-error">{err}</p>}
        <button
          disabled={loading || !token}
          data-testid="admin-reset-submit-btn"
          className="mt-8 w-full bg-[#111] hover:bg-[#99582A] transition-colors text-white py-4 font-semibold tracking-wide flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <KeyRound size={16} />}
          Set new password
        </button>
        <Link
          to="/admin/login"
          data-testid="admin-reset-back-link"
          className="mt-6 inline-block text-sm text-[#4A4A4A] hover:text-[#99582A]"
        >
          Back to sign in
        </Link>
      </form>
    </div>
  );
}
